import { combineReducers } from 'redux'
import { cond, always, equals, T } from 'ramda'
import { TYPES } from '../actions/user'

const setLanguage = (state = 'en', {type, payload}) => cond([
  [equals(TYPES.SET_LANGUAGE), always(payload)],
  [T, always(state)]
])(type)

export const userDataReducer = combineReducers({
  language: setLanguage
})


// WEBPACK FOOTER //
// ./src/reducers/userDataReducer.js